module.exports = __webpack_public_path__ + "img/1570767561.42a66cdd.jpg";